import { cn } from '@april9au/react-common/utils';

import { SectionHeader } from './section-header';

export type ProcessStep = {
  title: string;
  description: string;
};

/** Numbered step-by-step process list. Reusable for a selling/buying process, onboarding, or how-it-works pages. */
export function ProcessSteps({
  id,
  eyebrow,
  heading,
  description,
  steps,
  className,
}: {
  id?: string;
  eyebrow?: string;
  heading: string;
  description?: string;
  steps: Array<ProcessStep>;
  className?: string;
}) {
  return (
    <section id={id} className={cn('section', className)}>
      <div className="container container--narrow">
        <SectionHeader eyebrow={eyebrow} heading={heading} description={description} className="mb-12" />

        <ol>
          {steps.map((step, index) => (
            <li key={step.title} className="service-item">
              <span className="service-item__number">{String(index + 1).padStart(2, '0')}</span>
              <div>
                <h3 className="text-h3 mb-1">{step.title}</h3>
                <p className="text-body">{step.description}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
